import React from 'react';
import Table from 'components/shared/table';
import useFetch from 'hooks/useFetch';
import { routes } from 'constants/config';
import Skeleton from 'ui/Skeleton';
import InfoTooltip from 'components/shared/InfoTooltip';

const SettingsGamificationPoints = () => {
  const { data, loading } = useFetch(routes.GAMIFICATION.POINTING_SYSTEM);

  const PointRow = ({ name, value }) => (
    <Table.Row>
      <Table.Body.Cell size="s">{name}</Table.Body.Cell>
      <Table.Body.Cell size="s">
        {t('settings.tab.global_lesson.gamification.points', { value })}
      </Table.Body.Cell>
    </Table.Row>
  );

  return (
    <div className="Module panel_body row">
      <h3 className="SettingsContent-heading">
        {t('settings.tab.global_lesson.gamification.title')}
      </h3>
      <hr />
      <div className="fw-b mb-16">
        {t('settings.tab.global_lesson.gamification.pointing')}
        <InfoTooltip
          className="c-gray-light p-4"
          tooltip={t(
            'settings.tab.global_lesson.gamification.pointing_tooltip',
          )}
        />
      </div>
      {loading ? (
        <div data-testid="settingsGamificationLoadingSkeleton">
          <Skeleton count={3} height={24} className="mt-12" />
        </div>
      ) : (
        <Table alternate>
          <Table.Body>
            <PointRow
              name={t('activerecord.models.lesson.other')}
              value={data.lesson}
            />
            <PointRow
              name={t('activerecord.models.learning_paths/path.other')}
              value={data.path}
            />
            <PointRow
              name={t('settings.tab.global_lesson.certifications')}
              value={data.certification}
            />
          </Table.Body>
        </Table>
      )}
    </div>
  );
};

export default SettingsGamificationPoints;
